import {FormattedMessage} from 'react-intl'
import './styles.css'

const ErrorPage = ({error}) => {
  const {status, message} = error

  return (
    <div className="container" styleName="wrapper">
      <div className={`error-page error-page--${status}`}>
        <div className="d-flex align-items-end">
          <h1 className="bodo pr-4 tw-mb-0">
            <FormattedMessage id="error_page.oops" />
          </h1>
          <div>
            <FormattedMessage id="error_page.text_1" />
            <br />
            <FormattedMessage id="error_page.text_2" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
